const translations = {
    cancel: 'Cancel',
    chemicalsCount: 'Chemicals',
    crop: 'Crop',
    mixName: 'Mix Name',
    mixNamePlaceholder: 'e.g. Corn Pre-Emerge 2026',
    newMix: 'New Mix',
    saveMix: 'Save Mix',
    searchButton: 'Search',
    searchEmpty: 'Search for chemicals to add to your mix',
    searchPlaceholder: 'Search by product name or EPA number...',
    searchResults: 'Search Results',
    targetPest: 'Target Pest',
    targetPestPlaceholder: 'e.g. Broadleaf weeds'
};

export default translations;
